import { z } from "zod";

export const patchPlanSkipTicketSchema = z.object({
	planId: z.string(),
	ticketId: z.string().uuid(),
});
